import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getActiveUsersURL =
        this.basePath +
        environment.interop.dgaspc.nomenclatoare.user.getUsersList;
    private getUsersUrl =
        this.basePath + environment.interop.dgaspc.nomenclatoare.user.getUsers;

    constructor(private http: HttpClient) { }

    getUsersActive() {
        return this.http.get(this.getActiveUsersURL, this.httpOptions);
    }

    getUsers() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getActiveUsersURL
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id_user, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUsers:', error);
                    return throwError(error);
                })
            );
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
